import { useAuthStore } from '../../stores/auth';
import { useCircleStore } from '../../stores/circle';

export function Header() {
  const user = useAuthStore((s) => s.user);
  const circle = useCircleStore((s) => s.circle);
  const members = useCircleStore((s) => s.members);
  const online = useCircleStore((s) => s.onlineMembers);

  const others = members.filter((m) => m.user_id !== user?.id);
  const isPair = members.length === 2;
  const someoneOnline = others.some((m) => online.has(m.user_id));

  return (
    <header className="sticky top-0 z-30 border-b border-border-subtle bg-base/80 backdrop-blur">
      <div className="mx-auto flex w-full max-w-screen-sm items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-full bg-sage flex items-center justify-center text-white font-semibold">N</div>
          <div className="leading-tight">
            <div className="text-sm text-text-muted">{circle?.name ?? 'Circle'}</div>
            <div className="text-xs text-text-muted flex items-center gap-1.5">
              <span
                className={`inline-block h-1.5 w-1.5 rounded-full ${someoneOnline ? 'bg-sage' : 'bg-border-strong'}`}
                aria-label={someoneOnline ? 'online' : 'offline'}
              />
              {isPair ? (
                <span>{others[0]?.display_name ?? 'Partner'} {someoneOnline ? 'online' : 'offline'}</span>
              ) : (
                <span>{others.length} {others.length === 1 ? 'partner' : 'members'}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
